import Images from './Images'

interface Member {
  name: string
  program: string
  fieldOfInterest: string
  years: string
  favScientificFact: string
  funFact: string
  image: Images
}

const TeamMembers: Member[] = [
  {
    name: 'Benjamin Ouellet',
    program: 'Ph. D. in Biochemistry',
    fieldOfInterest: 'Synthetic biology and biofuels',
    years: 'Fourth!',
    favScientificFact:
      'It is estimated that there are more trees on earth than stars in the Milky Way.',
    funFact: 'I was supposed to be just the team mentor, and guess what…',
    image: Images.TeamBenjamin
  },
  {
    name: 'Éléonore Lemieux',
    program: 'M. Sc. in Animal Sciences',
    fieldOfInterest: 'Bacteriophage metagenomics',
    years: 'Second!',
    favScientificFact:
      'Genetically, whales are closer to goats than to seals or otters.',
    funFact: 'I can play 4 musical instruments.',
    image: Images.TeamEleonore
  },
  {
    name: 'Mathieu Giguère',
    program: 'B. Sc. Bioinformatics',
    fieldOfInterest: 'Evolutionary systems biology',
    years: 'Second!',
    favScientificFact:
      'Two-thirds of an octopus’ neurons reside in its arms, not its head.',
    funFact: 'I enjoy reading science-fiction and playing board games.',
    image: Images.TeamMathieu
  },
  {
    name: 'Kelly Godbout',
    program: 'Ph. D. in Molecular Medecine',
    fieldOfInterest: 'Genome Editing',
    years: 'First!',
    favScientificFact:
      'Water is the only substance whose solid phase has a lower density than its liquid phase. This is what has allowed life to exist underwater, despite the ice!',
    funFact: 'I am a ballerina and a black belt karateka.',
    image: Images.TeamKelly
  },
  {
    name: 'Arnaud Girard',
    program: 'M. Sc. Clinical and Biomedical sciences',
    fieldOfInterest: 'Mendelian randomization and regression modeling',
    years: 'First!',
    favScientificFact: 'Ants cannot die from falling.',
    funFact: 'I’m also the team mascot <3',
    image: Images.TeamArnaud
  },
  {
    name: 'Raphaël Gauthier',
    program: 'B. Sc. Microbiology',
    fieldOfInterest: 'Genetic and cells',
    years: 'Second!',
    favScientificFact:
      'Bismuth-209 is the most stable heavy isotope, with a half-life of 19 x 1018  years, or 1 billion times older than the universe.',
    funFact:
      'I love science, but I also have a passion for history and video games.',
    image: Images.TeamRaphael
  },
  {
    name: 'Éloise Lagüe',
    program: 'PharmD Program',
    fieldOfInterest: 'Aging and adaptation to physical activity',
    years: 'Third!',
    favScientificFact:
      'The protein kinase Hippo is named after the hippopotamus-like phenotype caused by its mutation.',
    funFact: 'I like to read too much :)',
    image: Images.TeamEloise
  },
  {
    name: 'Sabrina Gentil',
    program: 'M. Sc. Microbiology-immunology',
    fieldOfInterest: 'Viruses, viral evolution, and immunology',
    years: 'Second!',
    favScientificFact:
      'If you know the basics and have the right equipment, it’s possible to make Whiskey from diabetic urine. Type 2 diabetics excrete large amounts of sugar.',
    funFact:
      'My vocal cords are 75% paralyzed and I still can speak (no, I do not have COVID)',
    image: Images.TeamSabrina
  },
  {
    name: 'Anthony Lavertu',
    program: 'B. Sc. in Bioinformatics',
    fieldOfInterest: 'Artificial Intelligence and Machine Learning',
    years: 'First!',
    favScientificFact:
      'Cetaceans might have multiple languages as evolved as ours.',
    funFact: 'I like manual challenges as much as intellectual ones.',
    image: Images.TeamAnthony
  },
  {
    name: 'Vivian Robin',
    program: 'Ph. D. in Molecular Medicine',
    fieldOfInterest: 'Bioinformatics and Biological Network',
    years: 'Second!',
    favScientificFact: 'We all drink dinosaur urine',
    funFact: 'I once bought my weight in candy',
    image: Images.TeamVivian
  },
  {
    name: 'Jonathan Bessette',
    program: 'B. Eng. Software Engineering',
    fieldOfInterest: 'Fullstack Web Development and Clean Architecture',
    years: 'Third!',
    favScientificFact: 'A cloud can weigh around a million pounds!',
    funFact: 'I have just started cycling!',
    image: Images.TeamJonathan
  },
  {
    name: 'Olivier Lavoie',
    program: 'M. Sc. in Pharmaceutical sciences',
    fieldOfInterest: 'Neurobiology',
    years: 'Fourth!',
    favScientificFact:
      'The average human will walk the equivalent of 5 times around the Earth during their lifetime.',
    funFact: 'I walk a lot.',
    image: Images.TeamOlivier
  },
  {
    name: 'Thomas Mondor',
    program: 'B. Eng. Software Engineering',
    fieldOfInterest: 'Fullstack Web Development and Architecture',
    years: 'First!',
    favScientificFact: 'In the seahorse world, it\'s the male who gives birth',
    funFact: 'I\'m teaching a college programming course',
    image: Images.TeamThomas
  },
  {
    name: 'David Ferland',
    program: 'B. Eng. Software Engineering',
    fieldOfInterest: 'Fullstack Web Development and Architecture',
    years: 'First!',
    favScientificFact: 'Fungi are more closely related to animal than plants',
    funFact: 'I once ate a fried scorpion in the streets of Bangkok',
    image: Images.TeamDavid
  }
]

export default TeamMembers
